module.exports = __webpack_public_path__ + "media/logo.224142d4.svg";